import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api.js'

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Never retry a client error: a 400 or 403 will not become a 200, and retrying a
        // 401 fights the client's own refresh logic.
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status < 500) return false
          return failureCount < 2
        },
        staleTime: 30_000,
        refetchOnWindowFocus: true,
      },
      mutations: { retry: false },
    },
  })
}
